module.exports = __webpack_public_path__ + "static/media/crewstudio_app_video_preview.db2ab5b5.jpg";